// extracted by mini-css-extract-plugin
module.exports = {"container":"_1-gV8SpTVui7BTR0plNxjF","marginRight":"_3qpIYXGgRiMEu7JXE67TfR"};